"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var client_lib_js_player_framework_utils_1 = require("@sky-uk-ott/client-lib-js-player-framework-utils");
var HTML5LocalStorage = (function () {
    function HTML5LocalStorage(context) {
        this.context = context;
        this.setSecureItem = this.setItem;
        this.getSecureItem = this.getItem;
        this.removeSecureItem = this.removeItem;
    }
    HTML5LocalStorage.prototype.setItem = function (key, value) {
        var _this = this;
        return client_lib_js_player_framework_utils_1.promisifySynchronousMethod(function () { return _this.context.localStorage.setItem(key, value); });
    };
    HTML5LocalStorage.prototype.getItem = function (key) {
        var _this = this;
        return client_lib_js_player_framework_utils_1.promisifySynchronousMethod(function () { return _this.context.localStorage.getItem(key); });
    };
    HTML5LocalStorage.prototype.removeItem = function (key) {
        var _this = this;
        return client_lib_js_player_framework_utils_1.promisifySynchronousMethod(function () { return _this.context.localStorage.removeItem(key); });
    };
    HTML5LocalStorage.prototype.clear = function () {
        var _this = this;
        return client_lib_js_player_framework_utils_1.promisifySynchronousMethod(function () { return _this.context.localStorage.clear(); });
    };
    return HTML5LocalStorage;
}());
exports.HTML5LocalStorage = HTML5LocalStorage;
